import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import MuiButton from "@material-ui/core/Button";

import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import TextInput from "./TextInput";
import styled from "styled-components";
import SelectCard from "./SelectCard";
import {getCookieValue} from "../utils/getCookieValue";

import { Trans } from "../utils/i18n";
import HelpModal from "./HelpModal";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import {Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import dayjs from "dayjs";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import {last} from "lodash";


const ProductFound = styled.div`
  background: #F5F5F5;
  padding: 3rem;
  text-align: center;
  border-radius: 1rem;
  width: 80%;
  margin: 0 auto;
  margin-top: 3rem;
`;

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    //border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const MarginTop = styled.div`
  margin-top: 15px;
`

const ConfirmDevice = React.memo(function ({ setAddress, values, addCompany, addCoverageId, setAddressId, nextStep, validateSerialNumber, uppercase, setSerialnumber, }) {
    const { serialNumber: {product, success, address, order, problems, accessories, openOrders, }, selectedProduct, selectedCategory, manualDeviceSelection} = useFormState();

    return (
        <div>
            <div>
                <h3 className={'h3 mt-9'}><Trans i18nKey="common.deviceConfirm">Confirm your device</Trans></h3>
            </div>
            <div className={'bg-white p-6 b2x-shadow-md rounded-lg grid grid-cols-12 mt-3 gap-1'}>
                <div className={'col-span-12 md:col-span-3'}>
                    <div className={'px-12 py-6'}>
                        {
                            (product.image || selectedCategory?.image) &&
                            <img className={'max-w-full '} src={product.image || selectedCategory?.image}
                                 alt={product.description}/>
                        }
                    </div>
                </div>
                <div className={'col-span-12 md:col-span-6 flex flex-col items-start md:pl-6'}>
                    <div className={'flex-1'}>
                        <p><span className={'font-bold'}><Trans
                            i18nKey={'common.device'}>Device</Trans>:</span> {product.productcategory?.description} </p>
                        <p><span className={'font-bold'}><Trans
                            i18nKey="common.version">Version</Trans>:</span> {product.description} </p>
                        <p><span className={'font-bold'}><Trans
                            i18nKey="common.serialNumberDNS">Serial Number (DNS)</Trans>:</span> {values.serialnumber}
                        </p>
                    </div>
                </div>
                <div className={'col-span-12 md:col-span-3 flex items-end'}>
                    <MuiButton
                        variant="contained"
                        color={'secondary'}
                        onClick={nextStep}
                        id={'serialnumber-confirm'}
                    >
                        <Trans i18nKey={'orderEntry.confirmThisDevice'}>
                            Confirm this device
                        </Trans>
                    </MuiButton>
                </div>
            </div>
        </div>
    );
},
function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});

export default ConfirmDevice;
